import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ThemeSwitcherComponent } from '../../../shared/components/theme-switcher/theme-switcher.component';
import { AuthService } from '../../../shared/services/auth.service';
import { ThemeService } from '../../../shared/services/theme.service';
import { AdminSideNavComponent } from '../../components/admin-side-nav/admin-side-nav.component';
import { AdminShellService } from '../../services/admin-shell.service';

@Component({
    selector: 'app-admin-shell',
    standalone: true,
    imports: [RouterOutlet, TranslocoPipe, MatIconModule, ThemeSwitcherComponent, AdminSideNavComponent],
    templateUrl: './admin-shell.component.html',
    styleUrl: './admin-shell.component.scss',
})
export class AdminShellComponent implements OnInit, OnDestroy {
    constructor(
        private readonly router: Router,
        private readonly adminShellService: AdminShellService,
        private readonly authService: AuthService,
        public readonly themeService: ThemeService,
    ) {}

    public ngOnInit(): void {
        this.adminShellService.isOpen.set(true);
    }

    public ngOnDestroy(): void {
        this.adminShellService.isOpen.set(false);
        this.authService.markProfileOutdated();
    }

    public goBackToApp(): void {
        void this.router.navigate(['/v2']);
    }
}
